export default "__VITE_ASSET__DXgFS6uc__"